import type { Identifier } from "ra-core";
/** The database identity is assigned atomically and is immutable across renames. */
export const projectNumber = (project: { id: Identifier }) =>
  String(project.id);
export const projectTitle = (project: { id: Identifier; name?: string }) =>
  `Проект №${projectNumber(project)}${project.name?.trim() ? ` | ${project.name.trim()}` : ""}`;
